/**
 * What to do once a new Locale has been chosen, for hosts that can rebuild
 * themselves in place without navigating. Registered by the entry, fired by
 * ContentLocaleProvider.
 */
let handler: (() => void) | null = null;

export const setContentLocaleChangeHandler = (next: (() => void) | null) => {
  handler = next;
};

export const onContentLocaleChanged = () => {
  if (handler) {
    handler();
  }
};
